<!-- todo 仅用于数字控件 0 返回空 &千分位格式化，目前仅用于显示 临时使用 （财务审核 基本页签查看）-->
<template>
  <el-input-number :value="value" :disabled="disabled" :precision="precision" controls-position="right" />
</template>

<script>
import { formatNumberToThousands } from '../../../utils'

export default {
  name: 'NumberInput',
  props: {
    showValue: { type: [String, Number], default: '0', required: true },
    precision: { type: Number, default: 0 }, // 默认截取小数位数 2
    position: { type: String, default: '' },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      value: ''
    }
  },
  watch: {
    /* showValue(newVal) {
      if (newVal === 0) {
        this.value = ''
      }
    }*/
  },
  created() {
    this.value = 53500.000// this.showValue
    console.log('=======this.showValue', this.showValue)
    if (Number(this.value) === 0) {
      this.value = undefined
    } else {
      this.value = formatNumberToThousands(this.value, this.precision)
    }
    console.log('=======this.value', this.value)
  },
  methods: {
  }
}
</script>

<style scoped>
  #app .cargo-number-input >>> input{
    text-align:right;
  }
</style>
